import { TipShareDistributionConfig, TipShareContributionConfig } from '../types';

export interface TipShareContributionFormData {
  enableTipShareContribution: boolean;
  contributionPercentage: number;
  includeComps: boolean;
  includePromotions: boolean;
  includeTax: boolean;
}

export interface TipShareCalculationOptions {
  includeComps: boolean;
  includePromotions: boolean;
  includeTax: boolean;
}

export interface TipShareCalculationExample {
  grossSales: number;
  comps: number;
  promotions: number;
  tax: number;
  netSales: number;
  tipShareAmount: number;
}

export enum DistributionType {
  AUTOMATIC = 'automatic',
  MANUAL = 'manual',
}

export enum AutoDistributionMethod {
  BY_JOB = 'by_job',
  BY_LABOR_GROUP = 'by_labor_group',
}

export interface TipShareDistributionFormData {
  enableTipShareDistribution: boolean;
  distributionType: DistributionType | ''; // Allow empty string for no selection
  distributionMethod?: AutoDistributionMethod | ''; // Allow empty string for no selection
  recalculateOnPosImport: boolean;
  autoBalanceGridDistribution: boolean; // Only for manual
}

// Combined form data for the entire Tip Share page
export interface TipShareFormData extends TipShareContributionFormData, TipShareDistributionFormData {}

// Request Body Types (use the imported API types)
export type TipShareDistributionRequest = TipShareDistributionConfig;
export type TipShareContributionRequest = TipShareContributionConfig;
